export const PERSONAL_EXPENSES_KEY = 'PersonalExpenses';
export const PERSONAL_EXPENSES_BASE_PATH = '/expense/employee';
